import axios from 'axios'

/** Machine-readable codes returned by POST /me/accounts for emailAddress requests. */
export const EMAIL_ACCOUNT_ERROR_CODES = {
  ALREADY_LINKED: 'already_linked',
  EMAIL_ALREADY_ON_SWIFTAID: 'email_already_on_swiftaid',
} as const

export type EmailAccountErrorCode =
  (typeof EMAIL_ACCOUNT_ERROR_CODES)[keyof typeof EMAIL_ACCOUNT_ERROR_CODES]

export class EmailVerificationRequestError extends Error {
  code: EmailAccountErrorCode | string

  constructor(code: EmailAccountErrorCode | string, message?: string) {
    super(message ?? code)
    this.name = 'EmailVerificationRequestError'
    this.code = code
  }
}

type ApiErrorBody = {
  code?: string
  error?: string
  message?: string
  description?: string
}

/** Read Donor API error payload from an axios failure. */
export function parseEmailAccountApiError(error: unknown): {
  code?: string
  message?: string
  status?: number
} {
  if (!axios.isAxiosError(error)) {
    return {}
  }

  const data = (error.response?.data ?? {}) as ApiErrorBody
  return {
    status: error.response?.status,
    code: data.code,
    message: data.error ?? data.message ?? data.description,
  }
}

export function toEmailVerificationRequestError(
  error: unknown
): EmailVerificationRequestError | null {
  const { code, message, status } = parseEmailAccountApiError(error)
  if (status !== 409 || !code) {
    return null
  }
  return new EmailVerificationRequestError(code, message)
}
